import { render, staticRenderFns } from "./radish-pro-score.vue?vue&type=template&id=d1662b1c&scoped=true&"
import script from "./radish-pro-score.vue?vue&type=script&lang=js&"
export * from "./radish-pro-score.vue?vue&type=script&lang=js&"
import style0 from "./radish-pro-score.vue?vue&type=style&index=0&id=d1662b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1662b1c",
  null
  
)

component.options.__file = "radish-pro-score.vue"
export default component.exports